import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconArrowUpRight = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3332 7.66675H8.66658C8.11429 7.66675 7.66658 8.11446 7.66658 8.66675C7.66658 9.21903 8.11429 9.66675 8.66658 9.66675H12.919L7.95947 14.6263C7.56895 15.0168 7.56895 15.65 7.95947 16.0405C8.35 16.431 8.98316 16.431 9.37369 16.0405L14.3332 11.081V15.3334C14.3332 15.8857 14.781 16.3334 15.3332 16.3334C15.8855 16.3334 16.3332 15.8857 16.3332 15.3334V8.66675C16.3332 8.11446 15.8855 7.66675 15.3332 7.66675Z"
        />
      </svg>
    );
  }
);
